import { Component, OnInit, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TipoPontoFisico } from '../../comum/modelos/tipo-ponto-fisico';

@Component({
    selector: 'app-modal-tipo-ponto-fisico',
    templateUrl: './modal-tipo-ponto-fisico.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal-tipo-ponto-fisico.component.css']
})
export class ModalTipoPontoFisicoComponent implements OnInit {

    @Output() tipoPontoFisicoEvent: EventEmitter<TipoPontoFisico>;

    public tipoPontoFisico: TipoPontoFisico;

    constructor(private modalService: NgbModal) {
        this.tipoPontoFisicoEvent = new EventEmitter<TipoPontoFisico>();
    }

    cadastrar(content) {
        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false,
            windowClass: 'modalTipoPontoFisico',
            size: 'lg'
        };
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
            this.tipoPontoFisico = result;
            this.tipoPontoFisicoEvent.emit(this.tipoPontoFisico);
        }, (reason) => {
        });
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ponto-fisico/modal-tipo-ponto-fisico/modal-tipo-ponto-fisico.component.ts